import React, { useState, useEffect } from 'react'
import TemplatePreviewModal from './TemplatePreviewModal'
import TemplatePreviewDrawer from './TemplatePreviewDrawer'

interface TemplatePreviewHybridProps {
    open: boolean
    onClose: () => void
    imageUrlsData: string[]
    loading: boolean
    onCancel: () => void
    templateOptions?: any[]
    templateOption?: any
    systemTemplate?: any
    setTemplateOption?: (template: any) => void
    handleLoadMore?: () => void
    isLoading?: boolean
    hasMoreTemplates?: boolean
    handleGetTemplatePreview?: (templateId: string) => void
    previewSelection?: any
    setPreviewSelection?: (template: any) => void
    userPreferredTemplateResponse?: any
}

const TemplatePreviewHybrid: React.FC<TemplatePreviewHybridProps> = (props) => {
    const [isIpad, setIsIpad] = useState(false)

    // Detect iPad device
    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase()
        const isIpadDevice =
            /ipad/.test(userAgent) ||
            (/macintosh/.test(userAgent) && 'ontouchend' in document) ||
            (navigator.maxTouchPoints &&
                navigator.maxTouchPoints > 2 &&
                /Macintosh/.test(userAgent))

        if (isIpadDevice) {
            setIsIpad(true)
        }
    }, [])

    // Use drawer for iPad, modal for desktop
    if (isIpad) {
        return <TemplatePreviewDrawer {...props} />
    }

    return <TemplatePreviewModal {...props} />
}

export default TemplatePreviewHybrid
